var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.14,358V474.2l143.41.06c2.55-5.82,2.48-14.12-.92-19.49a19.81,19.81,0,0,0-15.92-9,30.63,30.63,0,0,0-27-39.16,33.45,33.45,0,0,0-44.4-36.05A32.86,32.86,0,0,0,333.14,358",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.74,456.11A42.78,42.78,0,0,1,51.6,413.86a42.79,42.79,0,0,1,42.54-9.63A44.93,44.93,0,0,1,163.92,366c7.62-14.56,27.86-20.81,42.37-13.1s20.63,28,12.81,42.46a29.2,29.2,0,0,1,29.29,47.23c23.72-10.46,54.9,10.56,54.11,36.47l-288.07-.83C16.49,474.38,23.59,456.8,40.74,456.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 216.27,
    width: 28.96,
    height: 223.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68,77.23a4.31,4.31,0,0,0-6.78-.2,29.91,29.91,0,0,0-7.17,18.84V200.43h19.18s1.21-90.77,1.21-104.56A31.35,31.35,0,0,0,350.68,77.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,157.47c0,.11-4.36.2-9.75.2s-9.74-.09-9.74-.2,4.36-.2,9.74-.2S356.83,157.36,356.83,157.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,169.61c0,.11-4.36.2-9.75.2s-9.74-.09-9.74-.2,4.36-.2,9.74-.2S356.83,169.5,356.83,169.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,96.78c0,.11-4.36.2-9.75.2s-9.74-.09-9.74-.2,4.36-.2,9.74-.2S356.83,96.67,356.83,96.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,108.92c0,.11-4.36.2-9.75.2s-9.74-.09-9.74-.2,4.36-.2,9.74-.2S356.83,108.81,356.83,108.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,121.06c0,.11-4.36.2-9.75.2s-9.74-.09-9.74-.2,4.36-.2,9.74-.2S356.83,121,356.83,121.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,133.2c0,.11-4.36.19-9.75.19s-9.74-.08-9.74-.19,4.36-.2,9.74-.2S356.83,133.09,356.83,133.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,145.33c0,.11-4.36.2-9.75.2s-9.74-.09-9.74-.2,4.36-.19,9.74-.19S356.83,145.22,356.83,145.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.09,77.68a4.31,4.31,0,0,0-6.78-.2,29.8,29.8,0,0,0-7.17,18.83V200.88h19.18s1.2-90.78,1.2-104.57A31.34,31.34,0,0,0,421.09,77.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,97.22c0,.11-4.36.2-9.74.2s-9.75-.09-9.75-.2,4.36-.19,9.75-.19S427.2,97.11,427.2,97.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,109.36c0,.11-4.36.2-9.74.2s-9.75-.09-9.75-.2,4.36-.2,9.75-.2S427.2,109.25,427.2,109.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,121.5c0,.11-4.36.2-9.74.2s-9.75-.09-9.75-.2,4.36-.2,9.75-.2S427.2,121.39,427.2,121.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,133.64c0,.11-4.36.2-9.74.2s-9.75-.09-9.75-.2,4.36-.2,9.75-.2S427.2,133.53,427.2,133.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,145.78c0,.11-4.36.2-9.74.2s-9.75-.09-9.75-.2,4.36-.2,9.75-.2S427.2,145.67,427.2,145.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,157.92c0,.11-4.36.2-9.74.2s-9.75-.09-9.75-.2,4.36-.2,9.75-.2S427.2,157.81,427.2,157.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,170.06c0,.11-4.36.2-9.74.2s-9.75-.09-9.75-.2,4.36-.2,9.75-.2S427.2,170,427.2,170.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,42.5c-4.17-3.15-10.06-2.6-14.14.79-12.13,10.08-18.11,25.17-18.11,37.12V215.49h47.8s3-115.77,3-135.08C407.92,68.68,400,50.53,389.37,42.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,42.5l.7.55c.44.39,1.17.9,2,1.72a42.49,42.49,0,0,1,6.47,7.81,63.23,63.23,0,0,1,7,14.51A49.26,49.26,0,0,1,407.81,77c.05.45.12.9.14,1.35l.06,1.38c.06.93,0,1.87,0,2.82,0,1.9,0,3.85-.06,5.84-.49,32-1.58,76.6-2.85,127.15v.19h-48.2v-.2c0-27,0-52.6,0-75.75,0-11.58,0-22.55,0-32.8,0-5.12,0-10.07,0-14.81v-7c0-2.28,0-4.49.07-6.67a46.62,46.62,0,0,1,2.39-12.13,51.31,51.31,0,0,1,4.6-10A50.74,50.74,0,0,1,375.44,43a12.49,12.49,0,0,1,5.84-2.54,11.46,11.46,0,0,1,4.66.27,11.28,11.28,0,0,1,2.63,1.16l.8.57-.82-.53a10.75,10.75,0,0,0-7.26-1.36,12.5,12.5,0,0,0-5.76,2.54,51.2,51.2,0,0,0-11.32,13.3,52.39,52.39,0,0,0-4.55,10,46.82,46.82,0,0,0-2.35,12.07v137l-.19-.2h47.8l-.19.2c1.28-50.55,2.42-95.16,3-127.14,0-2,0-3.95.07-5.84,0-1,.05-1.89,0-2.81l-.06-1.37c0-.45-.09-.9-.13-1.34a49,49,0,0,0-2.23-9.83A58.64,58.64,0,0,0,402,59.05a60.17,60.17,0,0,0-3.62-6.39,42.23,42.23,0,0,0-6.4-7.83,25.37,25.37,0,0,0-2-1.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.74,44.28s-18.4,14.78-18.55,34.59v52.81h7.88l-.48-46s-1-8.74,3.75-24.11A94,94,0,0,1,379.74,44.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,85.68c0,.11-11,.2-24.49.2s-24.5-.09-24.5-.2,11-.2,24.5-.2S407,85.57,407,85.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,104.06c0,.11-11,.19-24.49.19s-24.5-.08-24.5-.19,11-.2,24.5-.2S407,104,407,104.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,122.43c0,.11-11,.2-24.49.2s-24.5-.09-24.5-.2,11-.19,24.5-.19S407,122.32,407,122.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,140.81c0,.11-11,.2-24.49.2s-24.5-.09-24.5-.2,11-.2,24.5-.2S407,140.7,407,140.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.67,
    y: 214.16,
    width: 12.55,
    height: 8.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,226.75h0a4.87,4.87,0,0,1,1.75-3.82l1.83-1.76,12.55.15,1.11,1a5.28,5.28,0,0,1,2,3.57v.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 226.05,
    width: 22.05,
    height: 2.22,
    rx: 0.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.13 212.53 323.13 188.92 355.03 157.63 368.63 115.04 368.63 218.85 323.13 212.53",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.13 204.73 368.62 210.78 368.62 218.85 323.13 212.53 323.13 204.73",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.13,212.52l.82.1,2.38.32,9.1,1.22,33.22,4.54-.17.15c0-22.65,0-52.64-.05-85.43V115l.39.06c-4.89,15.27-9.48,29.64-13.62,42.58v0l0,0-32,31.25,0-.08c0,7.45,0,13.33-.06,17.37,0,2,0,3.57,0,4.63,0,.52,0,.91,0,1.19s0,.41,0,.41,0-.12,0-.39,0-.66,0-1.17c0-1.06,0-2.6,0-4.61,0-4,0-10-.06-17.43v0l0,0,31.86-31.34,0,.07L368.44,115l.39-1.21v19.65c0,32.79,0,62.78-.05,85.43V219l-.17,0-33.28-4.71L326.27,213l-2.35-.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.58,
    y: 214.16,
    width: 12.55,
    height: 8.14,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,226.75h0a4.89,4.89,0,0,1,1.76-3.82l1.83-1.76,12.54.15,1.11,1a5.3,5.3,0,0,1,2,3.57v.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.71,
    y: 226.05,
    width: 22.05,
    height: 2.22,
    rx: 0.95,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.8,
    cy: 202.24,
    r: 1.07,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.14,102.61c-.08-6.49-3.65-12.23-7.27-17.84a16.69,16.69,0,0,0-4.18-4.64,4.87,4.87,0,0,0-5.67,0,16.69,16.69,0,0,0-4.13,4.62c-3.61,5.61-7.19,11.35-7.26,17.84-.09,7.6,0,116.24,0,116.24h28.51S397.22,110.21,397.14,102.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.86,86.56a19.7,19.7,0,0,0-4.78-5.6,5.28,5.28,0,0,0-6.45,0,20.17,20.17,0,0,0-4.71,5.58,54.7,54.7,0,0,0-5.66,12l27.22-.09A52.21,52.21,0,0,0,390.86,86.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.48,97.88c0,.11-6.09.22-13.61.25s-13.61,0-13.61-.16,6.09-.22,13.61-.24S396.48,97.77,396.48,97.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,95.52a.52.52,0,1,1-.52-.52A.51.51,0,0,1,373,95.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.9,95.52a.52.52,0,1,1-.52-.52A.51.51,0,0,1,377.9,95.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.82,95.52a.52.52,0,1,1-.52-.52A.51.51,0,0,1,382.82,95.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.74,95.52a.52.52,0,1,1-.52-.52A.51.51,0,0,1,387.74,95.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66,95.52a.52.52,0,1,1-.52-.52A.51.51,0,0,1,392.66,95.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.14,102.61s0,.19,0,.57l0,1.67c0,1.48,0,3.66,0,6.48,0,5.66,0,13.89.06,24.22,0,20.67,0,49.73.07,83.3V219h-28.9V204.3c0-22,0-43,0-62,0-9.53,0-18.59,0-27.06q0-6.36,0-12.27a24,24,0,0,1,2.93-10.88c.82-1.62,1.71-3.14,2.62-4.6s1.77-2.88,2.75-4.19a15,15,0,0,1,3.36-3.35,5,5,0,0,1,4.36-.54,5.75,5.75,0,0,1,1.84,1.09,14.19,14.19,0,0,1,1.48,1.41A22.29,22.29,0,0,1,390.12,85c1.32,2.07,2.5,4,3.46,5.75a28.23,28.23,0,0,1,3.27,8.66c.09.53.16,1,.19,1.39a8.72,8.72,0,0,1,.08,1c0,.54,0,.82,0,.82s0-.28-.06-.82a9.21,9.21,0,0,0-.1-1,12.65,12.65,0,0,0-.21-1.38,28.47,28.47,0,0,0-3.32-8.6c-1-1.77-2.16-3.67-3.49-5.72a22.17,22.17,0,0,0-2.3-3,14.87,14.87,0,0,0-1.47-1.38,5.47,5.47,0,0,0-1.77-1.05,4.79,4.79,0,0,0-4.15.52,15,15,0,0,0-3.3,3.31c-1,1.3-1.81,2.74-2.73,4.19s-1.78,3-2.59,4.57A23.81,23.81,0,0,0,368.78,103q0,5.9,0,12.26c0,8.48,0,17.53,0,27.06,0,19.06,0,40,0,62v14.55l-.2-.2h28.51l-.19.19c0-33.57.05-62.63.07-83.3,0-10.33,0-18.56.05-24.22,0-2.82,0-5,0-6.48,0-.73,0-1.29,0-1.67S397.14,102.61,397.14,102.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,109.11a7.35,7.35,0,0,0-7.35,7.34h14.69A7.34,7.34,0,0,0,382.52,109.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.49,226.62h0a6.71,6.71,0,0,1,2.77-5.38l3.19-2.39h20.2l2.8,2.2a6.72,6.72,0,0,1,2.61,5.27v.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.39,
    y: 226.62,
    width: 36.18,
    height: 3.64,
    rx: 1.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.13,220.93H364.8V202.78a8.91,8.91,0,0,1,8.9-8.9h.53a8.91,8.91,0,0,1,8.9,8.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.13,220.93a1,1,0,0,1,0-.23c0-.16,0-.38,0-.64,0-.59,0-1.4,0-2.44,0-2.13,0-5.16-.07-8.89,0-1.87,0-3.92,0-6.11a8.65,8.65,0,0,0-2.73-6.16,8.84,8.84,0,0,0-3.18-1.91,9.5,9.5,0,0,0-3.85-.45,8.69,8.69,0,0,0-6.8,4A8.34,8.34,0,0,0,365.2,201,13.67,13.67,0,0,0,365,204c0,2.06,0,4.08,0,6,0,3.9,0,7.55,0,10.87l-.17-.16,13.26.08,3.72.05,1,0h.36a1.14,1.14,0,0,1-.32,0l-1,0-3.69,0-13.36.09h-.16v-.17c0-3.32,0-7,0-10.87v-6a14.76,14.76,0,0,1,.2-3.16,8.76,8.76,0,0,1,1.24-3,9.09,9.09,0,0,1,7.12-4.16,10,10,0,0,1,4,.48,9.05,9.05,0,0,1,3.3,2,8.91,8.91,0,0,1,2.81,6.41c0,2.22,0,4.29,0,6.19,0,3.74-.05,6.78-.07,8.91,0,1,0,1.83,0,2.41,0,.25,0,.45,0,.61A1.23,1.23,0,0,1,383.13,220.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.67 212.53 442.67 188.92 410.77 157.63 397.18 115.04 397.18 218.85 442.67 212.53",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.14 218.85 397.18 211.79 442.67 206.03 442.67 212.53 397.14 218.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.67,212.52l-.79.13-2.35.35-9,1.29L397.2,219l-.18,0v-.18c0-22.65,0-52.64,0-85.43V113.77l.38,1.21c4.87,15.28,9.45,29.65,13.58,42.59l-.05-.07,31.86,31.34,0,0v0c0,7.47-.05,13.38-.07,17.43,0,2,0,3.55,0,4.61,0,.51,0,.9,0,1.17s0,.39,0,.39,0-.14,0-.41,0-.67,0-1.19c0-1.06,0-2.61,0-4.63,0-4,0-9.92-.06-17.37l0,.08-31.94-31.25,0,0,0,0c-4.13-12.94-8.73-27.31-13.61-42.58l.38-.06v18.38c0,32.79,0,62.78,0,85.43l-.18-.15,33.22-4.54,9.1-1.22,2.38-.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.57,220.93H383.25V202.78a8.9,8.9,0,0,1,8.9-8.9h.53a8.9,8.9,0,0,1,8.89,8.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.57,220.93a2.07,2.07,0,0,1,0-.23c0-.16,0-.38,0-.64,0-.59,0-1.4,0-2.44,0-2.13,0-5.16-.07-8.89,0-1.87,0-3.92,0-6.11a8.69,8.69,0,0,0-2.73-6.16,8.84,8.84,0,0,0-3.18-1.91,9.52,9.52,0,0,0-3.85-.45,8.71,8.71,0,0,0-8,6.86,14.28,14.28,0,0,0-.19,3.07c0,2.06,0,4.08,0,6,0,3.9,0,7.55,0,10.87l-.17-.16,13.26.08,3.72.05,1,0h.35a1,1,0,0,1-.31,0l-1,0-3.69,0-13.36.09h-.16v-.17c0-3.32,0-7,0-10.87,0-1.95,0-4,0-6a14.16,14.16,0,0,1,.21-3.16,8.56,8.56,0,0,1,1.24-3,9.08,9.08,0,0,1,7.11-4.16,10,10,0,0,1,4,.48,9.06,9.06,0,0,1,6.12,8.42c0,2.22,0,4.29,0,6.19,0,3.74-.06,6.78-.07,8.91,0,1,0,1.83,0,2.41,0,.25,0,.45,0,.61S401.58,220.94,401.57,220.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.87,138.5c0,.11-6.26.2-14,.2s-14-.09-14-.2,6.27-.2,14-.2S396.87,138.39,396.87,138.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.87,168.62c0,.11-6.26.2-14,.2s-14-.09-14-.2,6.27-.19,14-.19S396.87,168.51,396.87,168.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.48,109.17l-6.1,7.28h4.2l4.86-6.2A9.09,9.09,0,0,0,383.48,109.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,458.36a33.1,33.1,0,0,0-35.66-39.45,23.18,23.18,0,0,0-32.79-22c-3.53-15.6-22.12-24.49-37.76-21.1S330.43,392,323.38,406.38a48.31,48.31,0,0,0-59,47.09c-17.54-3.72-37,5.89-44.75,22.07L481,477.85C483.46,468.2,474.38,457.49,464.45,458.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.71,231.12a26.82,26.82,0,0,1,6.61-2.87l1.36-6.54,11-.2,1.58,6.49a26.93,26.93,0,0,1,6.71,2.64L207.6,227l8,7.67-3.46,5.71A27.13,27.13,0,0,1,215,247l6.53,1.36.2,11.05L215.2,261a27.37,27.37,0,0,1-2.63,6.7l3.66,5.58-7.68,7.95-5.7-3.46a27.2,27.2,0,0,1-6.61,2.87l-1.36,6.54-11,.19-1.59-6.48a27,27,0,0,1-6.7-2.64L170,281.87l-8-7.67,3.46-5.71a27,27,0,0,1-2.87-6.61l-6.54-1.36-.19-11,6.48-1.59a27.25,27.25,0,0,1,2.64-6.7l-3.66-5.59,7.68-7.94,5.7,3.46Zm5.89,14.71a11.85,11.85,0,1,0,16.76-.29A11.86,11.86,0,0,0,180.6,245.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.12,290A18.13,18.13,0,0,1,330.6,288l.92-4.43,7.48-.13,1.08,4.39a18.58,18.58,0,0,1,4.54,1.79l3.79-2.48,5.38,5.2-2.34,3.87a18.31,18.31,0,0,1,1.94,4.48l4.43.92.13,7.48-4.39,1.08a18.19,18.19,0,0,1-1.79,4.54l2.48,3.78-5.2,5.39-3.87-2.34a18.41,18.41,0,0,1-4.47,1.94l-.92,4.43-7.49.13-1.08-4.39a18.34,18.34,0,0,1-4.54-1.79l-3.78,2.48-5.39-5.2,2.35-3.87a18.06,18.06,0,0,1-1.95-4.47l-4.43-.93-.13-7.48,4.4-1.08a18.31,18.31,0,0,1,1.78-4.54L317.05,293l5.2-5.39,3.87,2.35Zm4,10a8,8,0,1,0,11.36-.2A8,8,0,0,0,330.11,300Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.94,224.84a18.41,18.41,0,0,1,4.47-1.94l.92-4.43,7.49-.13,1.08,4.39a18.34,18.34,0,0,1,4.54,1.79l3.78-2.48,5.39,5.2-2.35,3.86a18.29,18.29,0,0,1,1.95,4.48l4.43.92.13,7.49-4.4,1.08a18.46,18.46,0,0,1-1.78,4.54l2.48,3.78-5.2,5.39L276,256.43a18.51,18.51,0,0,1-4.48,1.95l-.92,4.43-7.48.13-1.08-4.4a18.16,18.16,0,0,1-4.54-1.78l-3.79,2.48-5.38-5.2,2.34-3.87a18.48,18.48,0,0,1-1.94-4.48l-4.43-.92-.13-7.48,4.39-1.08a18.19,18.19,0,0,1,1.79-4.54l-2.48-3.79,5.2-5.38,3.87,2.34Zm4,10a8,8,0,1,0,11.35-.2A8,8,0,0,0,260.93,234.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33,199.06a7.85,7.85,0,0,0-10-9.73,8.41,8.41,0,0,0-13.08-7.16,5.86,5.86,0,1,0-10.35,5.5,5.48,5.48,0,0,0-5.49,8.86c-4.45-2-10.3,2-10.15,6.84l54-.16C83.87,202.49,82.54,199.19,79.33,199.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.84,124.61a7.85,7.85,0,0,0-10-9.73,8.43,8.43,0,0,0-13.09-7.16,5.86,5.86,0,1,0-10.34,5.5,5.48,5.48,0,0,0-5.5,8.86c-4.44-2-10.29,2-10.14,6.84l54-.16C210.39,128,209.06,124.74,205.84,124.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.21,56.48a7.84,7.84,0,0,0-10-9.72,8.42,8.42,0,0,0-13.08-7.17,5.86,5.86,0,1,0-10.35,5.5A5.48,5.48,0,0,0,61.27,54c-4.45-2-10.29,2-10.14,6.84l54-.16C104.76,59.91,103.42,56.61,100.21,56.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.66,270.77a7.84,7.84,0,0,0-10-9.72,8.43,8.43,0,0,0-13.09-7.17,5.86,5.86,0,1,0-10.34,5.5,5.48,5.48,0,0,0-5.49,8.86c-4.45-2-10.3,2-10.15,6.84l54-.16C465.21,274.2,463.88,270.9,460.66,270.77Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.57,477.73c0,.14-98.31.26-219.56.26s-219.58-.12-219.58-.26,98.29-.26,219.58-.26S467.57,477.59,467.57,477.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,461.77A30.06,30.06,0,0,1,90.32,424.5,32.28,32.28,0,0,1,140.45,397c5.47-10.45,20-15,30.43-9.41s14.82,20.11,9.2,30.5a21,21,0,0,1,21,33.93c17-7.51,39.44,7.58,38.87,26.2l-206.93-.6C34.54,474.89,39.64,462.26,52,461.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,461.77l-1.66.2a17.69,17.69,0,0,0-4.74,1.38,19.29,19.29,0,0,0-6.43,4.88,38.37,38.37,0,0,0-6,9.48l-.1-.16L240,478l-.26.25A23.58,23.58,0,0,0,238,468.8a27.75,27.75,0,0,0-5.29-8.31,31.5,31.5,0,0,0-17.37-9.71,24.37,24.37,0,0,0-14.11,1.51l-1,.46.73-.86a20.73,20.73,0,0,0-20.78-33.52l-.55.14.27-.5a22.43,22.43,0,0,0,1.08-17.77,21.71,21.71,0,0,0-11.35-12.93,22.57,22.57,0,0,0-16.65-.41,22.08,22.08,0,0,0-12.29,10.25l-.12.22-.21-.14A32.68,32.68,0,0,0,122,392a31.44,31.44,0,0,0-17.08,5.2A32.84,32.84,0,0,0,94,409.68a32.46,32.46,0,0,0-3.47,14.82v.24l-.22-.08a30.23,30.23,0,0,0-14.45-1.07,30.79,30.79,0,0,0-6.43,1.81,28.22,28.22,0,0,0-5.54,2.91A28.53,28.53,0,0,0,56,436.18a31.45,31.45,0,0,0-4.91,21.23,30.41,30.41,0,0,0,.64,3.27l.27,1.09c0-.14-.13-.43-.32-1.09a25.25,25.25,0,0,1-.68-3.25,30.8,30.8,0,0,1,.91-12.82,31.46,31.46,0,0,1,3.91-8.55,29.17,29.17,0,0,1,13.5-10.92,31.21,31.21,0,0,1,6.49-1.84,30.34,30.34,0,0,1,14.6,1l-.22.16a33.24,33.24,0,0,1,14.52-27.64,31.91,31.91,0,0,1,17.31-5.3,33.13,33.13,0,0,1,18.59,5.3l-.32.08a22.59,22.59,0,0,1,12.53-10.48,23,23,0,0,1,17,.41,22.2,22.2,0,0,1,11.62,13.21,23,23,0,0,1-1.1,18.17l-.29-.37a21.24,21.24,0,0,1,21.3,34.34l-.31-.4a24.83,24.83,0,0,1,14.41-1.55,32,32,0,0,1,17.67,9.87,28.48,28.48,0,0,1,5.38,8.46,24.27,24.27,0,0,1,1.78,9.66v.26H240l-206.93-.74h-.17l.08-.16a38.21,38.21,0,0,1,6-9.49,19.37,19.37,0,0,1,6.51-4.87,16.57,16.57,0,0,1,4.77-1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.2,457.66a20.56,20.56,0,0,0-21.8.51,29.15,29.15,0,0,0-46.95-20.47,27.62,27.62,0,0,0-44.88-23.63v63.66l123-.39A20.53,20.53,0,0,0,445.2,457.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.2,457.66s.44.26,1.28.83a20.36,20.36,0,0,1,3.28,3,20.92,20.92,0,0,1,3.7,6.18,20.2,20.2,0,0,1,1.24,9.68v.11h-.12l-123,.52h-.25v-.26c0-10.83,0-22.08,0-33.59V414l.1-.08a28.25,28.25,0,0,1,15.93-6,27.56,27.56,0,0,1,15.9,3.8,28.33,28.33,0,0,1,10.49,11.56,28,28,0,0,1,2.94,14.48l-.36-.19a29.8,29.8,0,0,1,8.52-4.52,30.5,30.5,0,0,1,9.05-1.55,28.23,28.23,0,0,1,16.06,4.43,30,30,0,0,1,9.95,10.63,31.33,31.33,0,0,1,2.54,5.92,31.76,31.76,0,0,1,1.1,5.72l-.2-.09a20.16,20.16,0,0,1,9.28-3.28,21.17,21.17,0,0,1,7.17.55,20.7,20.7,0,0,1,4.13,1.56c.86.49,1.29.76,1.29.76l-.34-.17-1-.53a20.49,20.49,0,0,0-11.25-2,20,20,0,0,0-9.16,3.29l-.17.11,0-.21a31,31,0,0,0-1.12-5.65,30.58,30.58,0,0,0-2.54-5.86,29.71,29.71,0,0,0-9.87-10.48,27.92,27.92,0,0,0-15.86-4.33,30.25,30.25,0,0,0-8.92,1.55,29.27,29.27,0,0,0-8.38,4.47l-.4.3,0-.49a27.46,27.46,0,0,0-2.92-14.24A27.74,27.74,0,0,0,363,412.1a27.12,27.12,0,0,0-15.61-3.72,27.76,27.76,0,0,0-15.64,5.89l.1-.2v63.66l-.26-.26,123-.26-.12.12a20.11,20.11,0,0,0-1.17-9.58,20.67,20.67,0,0,0-6.84-9.21l-.93-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.08,313.26a10.49,10.49,0,0,0-7.41-3.73,13.44,13.44,0,0,0-13.81,17c-6.29-2.28-14,1.51-16.33,7.76s.69,13.95,6.52,17.21,13.72,2,18.52-2.64c3.48,6.67,12.74,9.56,19.4,6s9.47-12.82,5.89-19.44a14.49,14.49,0,0,0,2.82-28.08c-6.12-2.1-12.16.37-15.6,5.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.08,313.26s0-.09.13-.24l.43-.67a14.48,14.48,0,0,1,2-2.33,12.63,12.63,0,0,1,10.84-3.33,14.1,14.1,0,0,1,7.36,3.68,15.65,15.65,0,0,1,4.6,8.48A14.08,14.08,0,0,1,468,329.41a16.28,16.28,0,0,1-4.3,4.13,14.59,14.59,0,0,1-5.84,2.19l.2-.37c3,5.58,1.68,13.55-3.64,18.2a13.58,13.58,0,0,1-10,3.09,15.64,15.64,0,0,1-9.85-4.49,13.75,13.75,0,0,1-2.31-3.14l.44.07A16.63,16.63,0,0,1,416.92,353a13.83,13.83,0,0,1-6.77-4.37,16.56,16.56,0,0,1-2.17-3.31,17.49,17.49,0,0,1-1.23-3.68,15.63,15.63,0,0,1-.24-3.79,13.83,13.83,0,0,1,.78-3.63,13,13,0,0,1,4.29-5.63,14.36,14.36,0,0,1,6.11-2.73,12.57,12.57,0,0,1,6.24.49l-.28.26a13.73,13.73,0,0,1,.16-7.51,13.87,13.87,0,0,1,3.4-5.79,13,13,0,0,1,4.94-3.12,14.48,14.48,0,0,1,4.87-.81,10.28,10.28,0,0,1,6.37,2.19,8.39,8.39,0,0,1,1.69,1.68l-.43-.43a12,12,0,0,0-1.34-1.15,10.31,10.31,0,0,0-6.29-2.05,14.43,14.43,0,0,0-4.77.84,12.71,12.71,0,0,0-4.8,3.09,13.51,13.51,0,0,0-3.27,5.66,13.33,13.33,0,0,0-.12,7.29l.11.39-.39-.14a12.11,12.11,0,0,0-6-.44,13.92,13.92,0,0,0-5.9,2.66,12.66,12.66,0,0,0-4.11,5.42,13.73,13.73,0,0,0-.74,3.5,15,15,0,0,0,.25,3.65,17,17,0,0,0,1.19,3.55,16.28,16.28,0,0,0,2.1,3.19,13.35,13.35,0,0,0,6.51,4.19,16.06,16.06,0,0,0,15.3-3.8l.26-.25.19.33a13.35,13.35,0,0,0,2.21,3,15.11,15.11,0,0,0,9.49,4.34,13.07,13.07,0,0,0,9.57-3,15,15,0,0,0,4.78-8.43,13.89,13.89,0,0,0-1.23-9.11l-.17-.32.36-.06a14.2,14.2,0,0,0,5.63-2.09,16,16,0,0,0,4.18-4,13.6,13.6,0,0,0,2.41-10.21,15.24,15.24,0,0,0-4.44-8.28,13.79,13.79,0,0,0-7.16-3.65,12.41,12.41,0,0,0-6.5.59,13.63,13.63,0,0,0-4.17,2.56A18.45,18.45,0,0,0,445.08,313.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,138a12.68,12.68,0,0,0-16.18-15.71A13.6,13.6,0,0,0,88,110.66a9.47,9.47,0,1,0-16.72,8.89,8.85,8.85,0,0,0-8.87,14.31c-7.19-3.17-16.63,3.2-16.39,11l87.27-.25C132.64,143.49,130.48,138.16,125.29,138Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,138l.71.05a7,7,0,0,1,2,.55,8.11,8.11,0,0,1,2.77,2,16,16,0,0,1,2.56,4l.08.16h-.17L46,145.17h-.26v-.25a11.12,11.12,0,0,1,.76-4.14,12.59,12.59,0,0,1,2.3-3.61,13.6,13.6,0,0,1,7.54-4.2,10.56,10.56,0,0,1,6.16.65l-.31.41a9.11,9.11,0,0,1,9.13-14.73l-.28.37c-2.57-4.91-.2-11.35,4.51-13.43a10.1,10.1,0,0,1,12.63,4.31l-.33-.08a13.81,13.81,0,0,1,21.44,11.77l-.22-.16a13.11,13.11,0,0,1,11.32,1.61,12.48,12.48,0,0,1,5,7,13.06,13.06,0,0,1,.36,5.43,10.28,10.28,0,0,1-.31,1.36l-.14.46.1-.45a12.66,12.66,0,0,0,.25-1.39,13,13,0,0,0-.44-5.36,12.28,12.28,0,0,0-5-6.84,12.86,12.86,0,0,0-11.07-1.51l-.22.07v-.24a13.58,13.58,0,0,0-1.46-6.2,13.35,13.35,0,0,0-19.39-5.19l-.21.14-.11-.22a9.65,9.65,0,0,0-12-4.08c-4.43,1.95-6.7,8.14-4.26,12.75l.27.5-.55-.14a8.6,8.6,0,0,0-8.61,13.9l.72.86-1-.45a10.12,10.12,0,0,0-5.86-.62,13.08,13.08,0,0,0-7.24,4A12,12,0,0,0,47,141a10.69,10.69,0,0,0-.73,3.93l-.25-.25,87.27-.1-.1.16a15.8,15.8,0,0,0-2.5-4,8.27,8.27,0,0,0-2.69-2.06A9.52,9.52,0,0,0,125.29,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.86,187.86a10.92,10.92,0,0,0-13.92-13.54,11.72,11.72,0,0,0-18.2-10A8.15,8.15,0,1,0,408.35,172a7.62,7.62,0,0,0-7.64,12.32c-6.19-2.73-14.32,2.75-14.11,9.51l75.12-.22C461.19,192.62,459.34,188,454.86,187.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.86,187.86s.22,0,.62,0a6.34,6.34,0,0,1,1.74.48,7,7,0,0,1,2.38,1.76,13.87,13.87,0,0,1,2.21,3.45l.06.14h-.15l-75.12.34h-.23v-.21a9.51,9.51,0,0,1,.65-3.56,11,11,0,0,1,2-3.11,11.7,11.7,0,0,1,6.49-3.62,9.23,9.23,0,0,1,5.3.56l-.26.35a7.84,7.84,0,0,1,7.86-12.67l-.24.31a8.35,8.35,0,1,1,14.75-7.84l-.28-.08a11.89,11.89,0,0,1,18.45,10.14l-.19-.14a11.35,11.35,0,0,1,9.75,1.38,10.76,10.76,0,0,1,4.3,6,11.15,11.15,0,0,1,.31,4.67,9.37,9.37,0,0,1-.26,1.18l-.13.4.09-.4a10.5,10.5,0,0,0,.22-1.19,11.28,11.28,0,0,0-.38-4.61,10.54,10.54,0,0,0-4.28-5.9,11.1,11.1,0,0,0-9.53-1.3l-.19.07v-.21a11.68,11.68,0,0,0-1.26-5.34,11.89,11.89,0,0,0-3.94-4.49,11.77,11.77,0,0,0-12.75,0l-.18.11-.09-.19a8.31,8.31,0,0,0-10.37-3.51,8.23,8.23,0,0,0-3.66,11l.23.43-.48-.12a7.4,7.4,0,0,0-7.41,12l.63.74-.89-.39a8.75,8.75,0,0,0-5-.53,11.35,11.35,0,0,0-6.24,3.48,10.26,10.26,0,0,0-1.89,3,9,9,0,0,0-.63,3.38l-.22-.21,75.12-.09-.08.14a13.56,13.56,0,0,0-2.15-3.44,7,7,0,0,0-2.31-1.78A7.38,7.38,0,0,0,454.86,187.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,54.4a7.91,7.91,0,0,1,10.09-9.81,8.49,8.49,0,0,1,13.18-7.22A5.9,5.9,0,1,1,338,42.92a5.52,5.52,0,0,1,5.54,8.92c4.48-2,10.37,2,10.22,6.89l-54.42-.15C299.74,57.85,301.08,54.53,304.32,54.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,54.4a6,6,0,0,0-1.67.45,7.15,7.15,0,0,0-3.21,3.78l-.09-.16c9.74,0,30.08,0,54.42,0l-.26.24c.11-3.31-2.83-6.41-6.26-7a6.22,6.22,0,0,0-3.6.38l-1,.45.73-.86a5.26,5.26,0,0,0-5.27-8.51l-.55.14.26-.5a5.66,5.66,0,1,0-10-5.32l-.12.22-.21-.14a8.44,8.44,0,0,0-9.14,0,8.57,8.57,0,0,0-3.75,7.06v.24l-.23-.08a8,8,0,0,0-6.85.93,7.68,7.68,0,0,0-3.1,4.24,8.32,8.32,0,0,0-.29,3.33c.1.75.23,1.17.21,1.15a5,5,0,0,1-.3-1.14,8,8,0,0,1,.21-3.39,7.76,7.76,0,0,1,3.12-4.41,8.24,8.24,0,0,1,7.11-1l-.22.16a8.67,8.67,0,0,1,13.47-7.41l-.32.08A6.14,6.14,0,1,1,338.24,43l-.29-.37A5.77,5.77,0,0,1,343.74,52l-.3-.41a6.75,6.75,0,0,1,3.9-.41,8.55,8.55,0,0,1,4.75,2.65,7.74,7.74,0,0,1,1.45,2.28,7,7,0,0,1,.49,2.62V59h-.26c-24.34-.08-44.68-.2-54.42-.31h-.17l.07-.16a7.18,7.18,0,0,1,3.35-3.77,4.46,4.46,0,0,1,1.27-.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.35,81.14l-5.06,1.75a20.41,20.41,0,1,1,2.5-6.88h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35,81.14s-.07-.12-.18-.34-.3-.56-.51-1L191.72,76h.13a.06.06,0,0,1-.09,0,.07.07,0,0,1,0-.08,20.42,20.42,0,0,0-.76-9.74,21.07,21.07,0,0,0-3-5.72,20.22,20.22,0,0,0-12.89-7.85,19.8,19.8,0,0,0-8.7.4,20.67,20.67,0,0,0-8.14,4.41,19.77,19.77,0,0,0-5.47,8,21.22,21.22,0,0,0-1.19,4.85c-.05.82-.12,1.64-.12,2.46l.06,1.22,0,.61.1.6A20.76,20.76,0,0,0,155,84a19.9,19.9,0,0,0,6.43,6,20.59,20.59,0,0,0,7.68,2.68,20.33,20.33,0,0,0,7.35-.36l1.64-.47c.54-.17,1-.4,1.55-.59a19.07,19.07,0,0,0,2.78-1.42,20.34,20.34,0,0,0,6.82-7,.05.05,0,0,1,0,0L193,81.57l1-.32.35-.11-.31.12-1,.35L189.31,83l0,0A20.23,20.23,0,0,1,182.52,90a18.94,18.94,0,0,1-2.8,1.46c-.52.19-1,.43-1.56.6l-1.67.49A20.63,20.63,0,0,1,169,93a21.09,21.09,0,0,1-7.81-2.69,20.17,20.17,0,0,1-6.55-6.09,21,21,0,0,1-3.4-8.89l-.09-.61,0-.62-.06-1.24c0-.83.06-1.67.12-2.5a21.33,21.33,0,0,1,1.2-4.94A20.26,20.26,0,0,1,158,57.22a21.08,21.08,0,0,1,8.29-4.48,20.17,20.17,0,0,1,8.85-.38,20.86,20.86,0,0,1,7.64,3,20.28,20.28,0,0,1,5.41,5.07,21.06,21.06,0,0,1,3,5.8,20.2,20.2,0,0,1,.69,9.84l-.14,0h0a.08.08,0,0,1,.1,0,.08.08,0,0,1,0,0c.81,1.67,1.44,3,1.87,3.86l.47,1A3.57,3.57,0,0,1,194.35,81.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.76 73.39 165.32 70.65 170.58 75.02 180.27 65.04 182.81 67.6 170.37 80.13 162.76 73.39",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.97,
    y: 242.25,
    width: 137.69,
    height: 235.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.32,178.15c-.07-.25,8-10.9,8-10.9l-7.14-7.47-8,6.31Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.55,123.93l1.87,6.52s4,5.94,5.42,6.65c.37.19.73.46,1.07.59,1.27.46,2.94,0,2.6-1.48a1.94,1.94,0,0,0,1.95-1.05c.57-1.12-.67-2.48-.67-2.48s1.44.37,2.09-.61c.54-.81-.22-1.88-.22-1.88s.64-1.1.32-1.71a13.38,13.38,0,0,0-1.58-1.84,38.11,38.11,0,0,0-2.61-5,14.53,14.53,0,0,0-3.05-3.06Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.81,130.33c0-.1-.59-.49-1.24-1.13s-1.06-1.26-1.16-1.21a3.52,3.52,0,0,0,2.4,2.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.05,132.87c0-.09-.58-.45-1.22-1s-1.07-1.17-1.16-1.11.22.75.91,1.38S326,133,326.05,132.87Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.84,132.58a4,4,0,0,0,1.4,2.16,6,6,0,0,0,2.14,1.43,20.06,20.06,0,0,0-1.89-1.7C321.47,133.54,320.93,132.54,320.84,132.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.91,299.89c-.1.2-1.26,2.4-.94,3.2a1.72,1.72,0,0,0,1.32.93,2.78,2.78,0,0,0,.79,1.67,3,3,0,0,0,1.79.52l.54.64a1.65,1.65,0,0,0,1.55.74,3,3,0,0,1,1.82-.14c.86.27,2.66-1.83,3.6-2.8s2.22-2.26,1.57-4.29c-.86-2.74-2-6.28-2-6.28l1.82-5.17-8.92.3-.39,2.25s-1.23.59-2.08,3.13A13.17,13.17,0,0,0,65.91,299.89Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.44,294.27S78,300.16,78,300.36s-2.51,5.38-3.7,6.17-2.75,1.67-2.75,1.67-1.34-.64-.19-2.61,2.48-3.92,2.48-3.92l-.85-2s-4.37-2.22-3.17-6.59",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,293.05a4.73,4.73,0,0,0-.15.55,3.75,3.75,0,0,0-.09.68,4.87,4.87,0,0,0,0,.93,5.5,5.5,0,0,0,.9,2.35,7.63,7.63,0,0,0,2.44,2.2l-.06-.07c.27.65.54,1.33.84,2v-.13c-.62.9-1.26,1.88-1.89,2.91a12.38,12.38,0,0,0-.92,1.65,2.39,2.39,0,0,0-.16,1,1.43,1.43,0,0,0,.44,1,2.21,2.21,0,0,0,.29.22l.07,0,.07,0,1.5-.91.74-.45a5.89,5.89,0,0,0,.72-.47,7.37,7.37,0,0,0,1-1.32c.29-.45.55-.91.81-1.36.49-.89.94-1.76,1.33-2.58.09-.21.18-.41.28-.61l.06-.16a.38.38,0,0,0,0-.1.5.5,0,0,0,0-.12l-.11-.32c-.16-.39-.32-.76-.46-1.12-.6-1.42-1.11-2.56-1.46-3.34l-.42-.9a1.49,1.49,0,0,0-.16-.3,1.69,1.69,0,0,0,.11.32c.09.25.21.55.36.93.34.83.8,2,1.37,3.37.14.36.28.74.44,1.13l.09.28v0h.07c-.08,0-.06,0-.06,0h0v0l-.06.14-.28.6c-.4.81-.85,1.67-1.35,2.56-.26.43-.52.89-.81,1.33a7,7,0,0,1-1,1.25,5.14,5.14,0,0,1-.69.45l-.73.44-1.49.9h.15a1.09,1.09,0,0,1-.22-.17,1.48,1.48,0,0,1-.2-1.62,12.45,12.45,0,0,1,.88-1.6c.63-1,1.26-2,1.87-2.92l0-.06,0-.07c-.29-.71-.58-1.38-.85-2l0,0,0,0a7.31,7.31,0,0,1-2.38-2.08,5.32,5.32,0,0,1-.93-2.25A8.51,8.51,0,0,1,69.77,293.05Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.39,
    y: 308.28,
    width: 51.48,
    height: 36.37,
    transform: "translate(6.46 -1.32) rotate(1.13)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.28,308.85a3.1,3.1,0,0,1-.32.51l-1,1.38c-.88,1.19-2.12,2.95-3.85,5a34,34,0,0,1-7,6.17,21.61,21.61,0,0,1-10.79,3.71,18,18,0,0,1-10.84-3.47,31.48,31.48,0,0,1-6.72-6.5c-1.65-2.09-2.83-3.89-3.64-5.14L45.17,309a2.57,2.57,0,0,1-.28-.53,2.8,2.8,0,0,1,.37.47l1,1.4c.85,1.21,2.08,3,3.75,5a32.2,32.2,0,0,0,6.71,6.33,17.78,17.78,0,0,0,10.55,3.35,21.56,21.56,0,0,0,10.55-3.59,34.58,34.58,0,0,0,7-6c1.76-2,3-3.7,4-4.85l1.08-1.33A2.58,2.58,0,0,1,90.28,308.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.25,311.26c0-.26,1.85-8.69,5.59-12.07,2.06-1.86,6.43-3.53,11,2.48l-1.58,2.23s-4.75-6.53-7.46-3.28c-1.47,1.76-4.1,5.8-4.28,9.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,304a3.86,3.86,0,0,0,.71-1,1.35,1.35,0,0,0,.08-1.22,1,1,0,0,0-.9-.43,1.63,1.63,0,0,0-.94.43,4.81,4.81,0,0,0-.67.81",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.43,302.53c-.05,0,0-.35.38-.78a2,2,0,0,1,.79-.61,1.3,1.3,0,0,1,1.29.15,1.16,1.16,0,0,1,.36,1.26,2.65,2.65,0,0,1-.43.86c-.33.44-.62.61-.67.56s.13-.31.35-.75a3.25,3.25,0,0,0,.29-.78.73.73,0,0,0-.22-.74c-.49-.37-1.15,0-1.49.3S70.5,302.58,70.43,302.53Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6,300.14a2.12,2.12,0,0,1,1.52-.94,1.4,1.4,0,0,1,1.5.79,1.78,1.78,0,0,1-.36,1.36,25.08,25.08,0,0,1-2.45,3.41",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.81,304.76c-.12-.09,1.21-1.73,2.43-3.92A.83.83,0,0,0,71,299.6a1.61,1.61,0,0,0-1.26-.12c-.74.24-1,.72-1.11.66s.13-.61,1-1a1.9,1.9,0,0,1,1.61.05,1.28,1.28,0,0,1,.68.8,1.58,1.58,0,0,1-.17,1.08A11.18,11.18,0,0,1,68.81,304.76Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.07,299.79a3,3,0,0,1,1-1.22,1.63,1.63,0,0,1,1.35-.26,1.2,1.2,0,0,1,.85,1,2,2,0,0,1-.44,1.12c-.7,1.07-1.47,2.41-2.28,3.4",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5,303.87c-.06-.05.24-.5.69-1.26.26-.44.52-.88.79-1.32a18,18,0,0,0,.92-1.58.91.91,0,0,0-.61-1.17,1.47,1.47,0,0,0-1.27.26c-.65.51-.88,1-1,1s0-.61.72-1.28a1.78,1.78,0,0,1,1.63-.43,1.47,1.47,0,0,1,.86.64,1.31,1.31,0,0,1,.11,1.16,4.1,4.1,0,0,1-.51.91l-.5.76c-.32.48-.62.92-.89,1.27C67,303.53,66.55,303.91,66.5,303.87Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,325.59A2.49,2.49,0,1,1,68,323.1,2.49,2.49,0,0,1,70.5,325.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,218.51s-9,2.85-12,5.82C92,232,80.2,244.25,76.83,249.61c-2.1,3.35-9.2,40-9.2,40l15.85.76,7.87-36.95,13.49-13.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.73,307.14l9.79,8.8,1.54.94s10.66-14.93,13.86-14.33l-8.29,33-2.65-.77L179.19,323.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1,327.31a1.39,1.39,0,0,0,1.3,1.32,1.34,1.34,0,0,0,1.32-1.28,1.46,1.46,0,0,0-1.39-1.39,1.38,1.38,0,0,0-1.22,1.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,335.62l-2.65-.76,8.94-31.39s1-1.31,2-.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.06,316.88c.16,0,0,.87.35,1.79s.89,1.52.79,1.65-1-.34-1.34-1.47S193.92,316.8,194.06,316.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.36,313.77c.17,0,.26.77.81,1.49s1.23,1.06,1.18,1.22-1,0-1.65-.88S196.21,313.74,196.36,313.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,312.84c0,.16-.86.18-1.64-.45s-1-1.48-.79-1.52.5.55,1.15,1.07S201,312.68,201,312.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.09,316.19c.13.1-.28.79-.44,1.72s-.06,1.71-.22,1.76-.56-.78-.35-1.87S190,316.08,190.09,316.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,176a3.47,3.47,0,0,1,4-.39,4.74,4.74,0,0,1,5.42,2.15,4.21,4.21,0,0,1,4.74,5.46,3.52,3.52,0,0,1,.8,6.63,3.38,3.38,0,0,1-3.65,5.66l-12.09-15.59A3.45,3.45,0,0,1,141.51,176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11,195.45a14.36,14.36,0,0,0-8.76-17.38l-.7-.26c-7.67-2.38-14,2.81-16.13,10.54l-8.35,26.88h0L125,230l9.51-4.7,2.74-6.69s7.63,1.59,10.43-5.59C149,209.5,151.19,202.14,153.11,195.45Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,219.21a18.6,18.6,0,0,1-8.34-6.3s.26,6,7.62,8.08Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.51,202a1.1,1.1,0,0,1-1.38.67,1.07,1.07,0,0,1-.72-1.33,1.11,1.11,0,0,1,1.39-.67A1,1,0,0,1,148.51,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,199.44c-.17.08-.74-.79-1.85-1.2s-2.13-.16-2.19-.34.18-.28.63-.4a2.92,2.92,0,0,1,1.82.11,2.82,2.82,0,0,1,1.41,1.12C150.24,199.11,150.26,199.4,150.17,199.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.84,198.9a1.11,1.11,0,0,1-1.39.67,1,1,0,0,1-.71-1.33,1.1,1.1,0,0,1,1.38-.67A1.07,1.07,0,0,1,138.84,198.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63,195.31c-.18.08-.74-.79-1.85-1.2s-2.13-.16-2.2-.34.18-.28.64-.4a3,3,0,0,1,3.23,1.22C139.69,195,139.72,195.27,139.63,195.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.15,205.61c.19,0,.46,1,1.38,1.72s2,.82,2,1-.26.21-.73.18a3.08,3.08,0,0,1-1.7-.67,2.89,2.89,0,0,1-1-1.51C136,205.9,136.06,205.62,136.15,205.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.2,204.89a7.3,7.3,0,0,1,1.92.35c.3.08.58.12.71-.06a1.55,1.55,0,0,0,.12-.9c0-.79,0-1.61,0-2.47a39.31,39.31,0,0,1,.24-6.34,40,40,0,0,1,.27,6.34c0,.86,0,1.68,0,2.47a1.68,1.68,0,0,1-.27,1.16.73.73,0,0,1-.62.24,2.07,2.07,0,0,1-.5-.11A8,8,0,0,1,140.2,204.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.82,190.56c-.13.31-1.16.07-2.4.14s-2.26.36-2.4.06c-.06-.14.14-.43.56-.71a3.8,3.8,0,0,1,1.82-.55,3.55,3.55,0,0,1,1.83.4C140.67,190.14,140.87,190.41,140.82,190.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,196.3c-.27.21-1-.29-1.92-.57s-1.79-.32-1.9-.64c0-.15.16-.38.58-.52a2.89,2.89,0,0,1,3.08,1C151.15,195.91,151.19,196.2,151.06,196.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,192.53s-.21-5.23-2-7.1c-2.16-2.27-4.38.2-6.62-1.44s-4.31-3.82-7.61-2.84c-3.6,1.07-2.85,3.06-4.22,6.19-5.57,12.71-9.32,15.49-7.7,9.13.18-.7-1.48-1.93-.69-4.86,1-3.8,2.54-8.31,4.34-10.6,1.51-1.94,3.33-3,6.2-3.81,4.53-1.31,9.42.45,12.59,2S156.07,187,153.65,192.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05,196.44a2.08,2.08,0,0,0-1.41-2.67c-1.39-.38-3.18-.18-4.13,2.63-1.69,5,3.67,5.66,3.72,5.52S125.36,198.54,126.05,196.44Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.78,199.68s-.1,0-.27,0a1,1,0,0,1-.66-.21,2.28,2.28,0,0,1-.34-2.27,2.89,2.89,0,0,1,.67-1.16,1.08,1.08,0,0,1,.88-.45.47.47,0,0,1,.43.42c0,.16,0,.25,0,.27s.13-.05.16-.27a.56.56,0,0,0-.09-.38.67.67,0,0,0-.44-.29,1.3,1.3,0,0,0-1.17.46,3.2,3.2,0,0,0-.77,1.29,2.39,2.39,0,0,0,.54,2.59,1,1,0,0,0,.84.14C123.73,199.79,123.8,199.69,123.78,199.68Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.72,186.93a5.09,5.09,0,0,0,1.73,1.75,1.72,1.72,0,0,0,2.21-.47c.19-.32.25-.75.58-.93s.84.07,1.24.27a3.35,3.35,0,0,0,4.11-1,1.42,1.42,0,0,0,1.71.83,7.49,7.49,0,0,0,1.88-.93,2.17,2.17,0,0,1,2-.21c.35.19.61.53,1,.64.67.18,1.27-.46,1.61-1.06s.69-1.33,1.37-1.47,1.22.3,1.78.61,1.39.46,1.76-.07a1.25,1.25,0,0,0,.11-1,3.4,3.4,0,0,0-3.31-2.63,4.62,4.62,0,0,0-7.64-3.82,4.69,4.69,0,0,0-7.62-1,3.4,3.4,0,0,0-5.33,3.28,3.23,3.23,0,0,0-2.56,1.79,1.85,1.85,0,0,0,1.29,2.5,1.88,1.88,0,0,0,2.39,2.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.29,183.83a1.25,1.25,0,0,0-.05,1.07,1.72,1.72,0,0,0,.77,1,1.84,1.84,0,0,0,1.55.12l-.19-.11a5.15,5.15,0,0,0,.52,1.6,3,3,0,0,0,.69.89,2.32,2.32,0,0,0,2.69.18,3.06,3.06,0,0,0,.78-.87,1.44,1.44,0,0,0,.19-.39s-.12.11-.29.32a3.71,3.71,0,0,1-.8.76,2.14,2.14,0,0,1-3-1,5.23,5.23,0,0,1-.51-1.5l0-.18-.17.07a1.57,1.57,0,0,1-1.33-.07,1.5,1.5,0,0,1-.71-.8A2.35,2.35,0,0,1,127.29,183.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.83,176.07s.11.08.3.26a1.83,1.83,0,0,1,.52.94l0,.11.1-.06a6.61,6.61,0,0,1,3.11-1,5.18,5.18,0,0,1,2.1.3,4.26,4.26,0,0,1,1.87,1.38,4.36,4.36,0,0,1,.8,1.65,3.57,3.57,0,0,1,0,1.69l0,.16h.16a3,3,0,0,1,2,1,2.84,2.84,0,0,1,.67,1.62,3.93,3.93,0,0,1-.24,1.58,1.28,1.28,0,0,0,.21-.38,3,3,0,0,0,.2-1.21,3,3,0,0,0-.66-1.76,3.15,3.15,0,0,0-2.11-1.14l.12.17a3.77,3.77,0,0,0,0-1.83,4.71,4.71,0,0,0-.85-1.76,4.52,4.52,0,0,0-2-1.47,5.17,5.17,0,0,0-2.23-.29,6.39,6.39,0,0,0-3.18,1.16l.13,0a1.77,1.77,0,0,0-.63-1A.82.82,0,0,0,140.83,176.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,406.55h0l1.15,17.81s14.15,15.5,13.05,18.74l-33.14-13.59,1.2-2.64,3.23-7.08-3-12.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,421.66a1.45,1.45,0,0,0-1.56,1.16,1.32,1.32,0,0,0,1.91,1.4,1.42,1.42,0,0,0,.28-2.31,1.06,1.06,0,0,0-.77-.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,429.51l1.2-2.64,31.32,14s1.21,1.24.62,2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.26,426.35c-.08.16-.92-.09-1.92.1s-1.72.7-1.84.57.5-1,1.73-1.17S123.35,426.22,123.26,426.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75,429.1c0,.17-.84.16-1.67.62s-1.29,1.12-1.44,1,.11-1,1.15-1.58S125.81,429,125.75,429.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,434.07c-.16,0-.06-.93.72-1.65s1.68-.75,1.7-.59-.65.44-1.28,1S125.79,434.12,125.62,434.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,421.78c-.07.16-.88-.06-1.87,0s-1.75.42-1.84.28.63-.79,1.79-.89S121.68,421.64,121.6,421.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.14,280.48a33.33,33.33,0,0,0-4.24,10.91,31.75,31.75,0,0,0,.92,15.46c1.31,3.86,19.6,53.47,19.6,53.47l2.09,26.05,6.32,32.69,19.8-1s-1.83-51.48-2.62-59c-.86-8.16-11.94-58.3-11.94-58.3l7.23-18.05L82.67,271.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.55,441.37c-.06.13-7.2-3-16-7s-15.8-7.36-15.74-7.49,7.2,3,16,7S134.61,441.24,134.55,441.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.63,418.13a92.57,92.57,0,0,1-9.89.73,93.76,93.76,0,0,1-9.91.2,94.32,94.32,0,0,1,9.89-.72A95.58,95.58,0,0,1,123.63,418.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.56,221l-1.12-2.53c-7.42-3.09-12.84-6.18-17.36-6.1l-3.49,3.41c-4,2.54-12,6.44-14.12,9.43l-9.8,18.94L79.13,275.89c-1.25,1.94-3.92,4.81-.95,7.67l27,3,9.6.17c2-.26,7.11,1.19,7.72-2,1.09-5.62,18.88-43.39,20.16-48.33l-.56-8.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,236.31c-2,5.33-3.43,13.57-10.93,18.52-4.15,2.73-10.25,4.38-15,5.88-5.61,1.78-13.07,4.05-13.07,4.05l-4.74,8.68,8.43,1.1s9.92-3.16,13.83-4.79c8.42-3.5,5.53-2.36,8.44-4.32,4.17-2.6,9.86-10.26,14-29.63",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,222.08a15.27,15.27,0,0,1-2.63-.05c-1.61-.07-3.84-.15-6.29,0a39.6,39.6,0,0,0-6.23.78,21.5,21.5,0,0,1-2.55.57s.21-.14.63-.32a18.33,18.33,0,0,1,1.83-.61,30.34,30.34,0,0,1,6.29-.94,42.52,42.52,0,0,1,6.35.17A12.21,12.21,0,0,1,122,222.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,218a18.08,18.08,0,0,1-2.9-.45c-1.78-.33-4.24-.77-7-1.11a53.75,53.75,0,0,0-7-.41c-1.8,0-2.91.16-2.92.08s.26-.1.77-.2a20.08,20.08,0,0,1,2.14-.24,38.22,38.22,0,0,1,7.1.25,64.47,64.47,0,0,1,7,1.27A14.89,14.89,0,0,1,136,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.47,225.2a3.22,3.22,0,0,1-.26.61l-.85,1.71c-.76,1.54-1.8,3.68-3.08,6.29-2.58,5.33-6,12.75-9.85,20.92-1.93,4.09-3.8,8-5.56,11.46-.89,1.75-1.73,3.41-2.56,4.94s-1.63,2.94-2.23,4.28A12.89,12.89,0,0,0,77,279.17a8,8,0,0,0,.19,2.95,7.16,7.16,0,0,0,1.09,2.28,2.62,2.62,0,0,1-.44-.5,5.32,5.32,0,0,1-.84-1.73,8,8,0,0,1-.29-3,12.52,12.52,0,0,1,1.08-3.88c.59-1.37,1.39-2.79,2.18-4.33s1.64-3.2,2.51-4.95c1.74-3.51,3.59-7.39,5.52-11.47,3.84-8.17,7.32-15.57,10-20.86,1.32-2.65,2.44-4.77,3.23-6.22l.93-1.67A3.06,3.06,0,0,1,102.47,225.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.88,317.94c1.4.44,48.4-17.8,48.4-17.8l39.85,30.3,2.91,1.17,6.49-18S164.64,286,155.18,277c-2.5-2.37-7.33-4.79-11.6-4.18-9.91,1.43-47.55,14-47.55,14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,313.77a19,19,0,0,0,10.57,3.1l4.72-.48-.92-4.25S100.33,314.28,97.19,313.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.15,309.62a3.63,3.63,0,0,1-.92.45c-.59.26-1.47.6-2.57,1a56.47,56.47,0,0,1-8.79,2.43,32.76,32.76,0,0,1-9.11.51c-.58-.05-1.11-.13-1.57-.21s-.85-.15-1.16-.23a3.76,3.76,0,0,1-1-.3c0-.09,1.43.23,3.74.37a37.7,37.7,0,0,0,9-.65,76.47,76.47,0,0,0,8.76-2.26C117.76,310,119.12,309.55,119.15,309.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,293.31a32,32,0,0,1-.26,3.39c-.1,1.86.07,3.38-.08,3.4a9.77,9.77,0,0,1,.34-6.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.2 181.59 164.95 191.27 177.25 196.28 182.46 182.47 174.75 179.63 171.2 181.59",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94,173.36a2.42,2.42,0,0,1-.22-1.81,5.16,5.16,0,0,1,1.62-2s.5,3,.42,3.09Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.57,183.58l-4.49-7.33.27-6s-.24-4.5,1.92-5.24c0,0,1.3-.69,2.12.2,0,0,.24-1.13,1.94-1.06l1.19.65s.79-1,1.62-1a3.39,3.39,0,0,1,1.79.93s.43-.88,1.73-.5,2.68,2.79,3,3.62a46.6,46.6,0,0,1,1.5,9.31c-.13,1.73-2,6-2,6Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.73,170.71s-2.14,2-2.6,2.59a22.65,22.65,0,0,0-1.06,2.79c-.33.67-1.3,1.48-.49,2a2,2,0,0,0,2.48-.46,42.91,42.91,0,0,0,2.52-4.69Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,177.62a3.73,3.73,0,0,0-.51,2.78,1.92,1.92,0,0,0,2,1.42,1.8,1.8,0,0,0,2.17,1.86s-.6.66.51,1.1l3.16-4.06s.44-.36.42-1.67c0-.87-.42-2.29-1.6-1.93,0,0-.16-1.53-1.24-1.89s-1.4.4-1.4.4a1,1,0,0,0-1.11-.49C166.5,175.23,165,177.62,165,177.62Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,237.19a10.08,10.08,0,0,1-.09-13.49,8.26,8.26,0,0,1,2.09-1.68c5.24-2.91,30.78-12.18,30.78-12.18l13.07-25.06L181.58,188s-10.28,31.64-17.93,36.32c-8.78,5.38-24,13.68-29.56,15.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09,239.71a1.45,1.45,0,0,1,.34-.15c.23-.09.58-.21,1-.4.89-.37,2.21-.93,3.87-1.73,3.33-1.58,8.1-4.05,13.91-7.31,2.91-1.63,6.09-3.45,9.46-5.5a10.34,10.34,0,0,0,2.36-1.77,20.67,20.67,0,0,0,1.95-2.37,50,50,0,0,0,3.33-5.55,138.28,138.28,0,0,0,5.78-12.79c1.81-4.53,3.57-9.31,5.22-14.26l.18.33-9.12-2.09L167.71,185l.29-.13c-4.64,8.86-9.05,17.3-13.09,25l0,.09-.08,0c-7,2.54-13.44,5-19.16,7.17-2.86,1.11-5.54,2.18-8,3.23-1.23.53-2.4,1.05-3.48,1.62a8,8,0,0,0-2.63,2.2,9.52,9.52,0,0,0-2.11,5.4,10.67,10.67,0,0,0,.67,4.31,13,13,0,0,0,1.84,3.19s-.06-.05-.16-.17-.27-.3-.46-.55a10.15,10.15,0,0,1-1.57-9.57,10,10,0,0,1,1.57-2.79,8.12,8.12,0,0,1,2.7-2.3c1.09-.59,2.26-1.12,3.49-1.66,2.45-1.07,5.13-2.16,8-3.28,5.71-2.26,12.15-4.69,19.14-7.25l-.13.11c4-7.74,8.44-16.19,13.06-25.07l.09-.17.19,0,4.7,1.08,9.12,2.09.28.07-.09.27q-2.49,7.46-5.25,14.29a134.74,134.74,0,0,1-5.83,12.81,48,48,0,0,1-3.39,5.59,19.63,19.63,0,0,1-2,2.42,10.82,10.82,0,0,1-2.45,1.82c-3.38,2-6.57,3.84-9.5,5.46-5.84,3.22-10.64,5.64-14,7.18-1.68.77-3,1.3-3.92,1.64-.45.18-.81.28-1,.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.54,141.76c-2.22,1.31-31.74,22.61-34.27,29.85s6.92,59.69,6.92,59.69l21-1-5.59-49.84,42-24.87,2.83-26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,152.6,287,178s3.24,11.54,6,19.09,7.42,20.13,7.42,20.13l5.09,16.72,16.42-3.63s-6.13-26.75-7.71-37.06a156.45,156.45,0,0,0-5.34-21.62l-13.06-33L281.61,120Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,151s18.43,7.07,24.54,5.8,16.3-16.31,16.3-16.31l15,15.19L300,149.12l-1.47-5.86s-26.06-6.73-26.11-6.81-9.44,0-9.44,0L247.2,147.34l-17.08.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4,217.4l5.44,17.18,8.21,12.35a1.85,1.85,0,0,1-.62,2.63h0a1.84,1.84,0,0,1-1.69.07c-3.45-1.61-15.86-7.53-16.46-8.86S303.35,223,303.35,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.43,249.56l-18.54-9.94.24.72a2.81,2.81,0,0,0,1.21,1.5c1.52.9,5.76,3.3,15.35,7.81a1.85,1.85,0,0,0,1.74-.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,243.44a4,4,0,0,1,2.87-2.88c0-.05-.26-.11-.67,0a2.9,2.9,0,0,0-1.44.79,3,3,0,0,0-.79,1.44C321.88,243.18,321.94,243.44,322,243.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,245.31c.11,0,.47-.7,1.26-1.25a13.69,13.69,0,0,1,1.59-.78,2,2,0,0,0-1.82.46C324.11,244.37,323.88,245.29,324,245.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.73,241.28a18.51,18.51,0,0,1,1.81-2.05,19.18,19.18,0,0,1,2.33-1.46,5,5,0,0,0-4.14,3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.64,236.2c.08.09.89-.63,2.1-1.09s2.28-.5,2.28-.62a3.59,3.59,0,0,0-2.43.25A3.55,3.55,0,0,0,316.64,236.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.26,177a5.3,5.3,0,0,1,3.19,1.05,5.45,5.45,0,0,1,2.35,2.4c-.12.1-1.1-1-2.63-2S221.22,177.13,221.26,177Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,180.69c0,.05-.33.47-1.09,1a8.78,8.78,0,0,1-3.27,1.27,9,9,0,0,1-3.5-.09,3,3,0,0,1-1.35-.55,16.14,16.14,0,0,0,4.76.12A17,17,0,0,0,305,180.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.26,217.48l.7,15.92s-16,6-16.11,9l30.92-.25-1.19-22.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.77,242.16l-.11-2.5-29.6,1.17s-1.37.61-1.21,1.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.46,233.24c0,.15.76.22,1.5.7s1.15,1.11,1.29,1.05-.09-.94-1-1.5S215.42,233.11,215.46,233.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.22,234.61c0,.15.63.4,1.14,1s.67,1.31.83,1.3.23-.86-.42-1.64S212.23,234.47,212.22,234.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.41,238.51c.14,0,.34-.73,0-1.55s-1.1-1.15-1.17-1,.38.56.7,1.24S210.26,238.49,210.41,238.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.77,99.86l19.81,27.57,8,5.83-2.37,6.19-11.19,9.94s18.54,7.69,25.36,3.25,13.32-15.2,13.32-15.2l16.72,15.93,21-8.36s-9.19-18.33-21.89-28.78L275,93.05,261,71.62l-17,5.54L219.82,94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.55,89.51c1.14,0,13.88,7.46,13.88,7.46l2.78-16-2.07-3.77,4.13,1.5,6.65,6.42,16.55,26.1c-1.18,6.64-5.25,16.5-5.37,20,0,0-17.59-1.5-21.63-10s-12.63-24-12.63-24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08,106.77c0,1.43,4.66,21.36,8.54,22.44s9.93,2.1,9.93,2.1v-9.57l-15.62-18.29-.46-4.9-5.73-.66L242.33,105Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7,96.16s-3.85,3.38-4.93,3.7-5.17,11.4-5.17,11.4l-10.49,26.05-18.45,24.62,10.39,9.68s23.27-23.48,24.91-29.79l11.46-23.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.81,136.45c-.06-.06.91-1,2.33-2.77s3.31-4.16,5.3-6.93l5.09-7.12c.66-.91,1.21-1.63,1.6-2.12a3.53,3.53,0,0,1,.65-.73,27.27,27.27,0,0,1-1.95,3.06c-1.24,1.86-3,4.43-5,7.21a79.35,79.35,0,0,1-5.45,6.87c-.75.84-1.39,1.48-1.86,1.91S266.83,136.48,266.81,136.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.69,132.77a15.3,15.3,0,0,1-2.94-.39c-1.8-.32-4.27-.85-7-1.57s-5.1-1.5-6.83-2.11a15.87,15.87,0,0,1-2.74-1.13,18.33,18.33,0,0,1,2.86.78c1.74.52,4.16,1.24,6.85,2s5.13,1.3,6.91,1.72A17.44,17.44,0,0,1,254.69,132.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.11,107.66a3.69,3.69,0,0,1,.69.71c.42.49,1,1.19,1.72,2.07,1.44,1.76,3.4,4.22,5.53,7s4,5.22,5.41,7c.68.91,1.23,1.65,1.59,2.17a3.56,3.56,0,0,1,.53.84,4,4,0,0,1-.69-.72c-.42-.48-1-1.19-1.72-2.07-1.44-1.76-3.4-4.21-5.53-6.94s-4-5.21-5.41-7c-.68-.91-1.22-1.65-1.59-2.17A3.56,3.56,0,0,1,218.11,107.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,83.59a21.5,21.5,0,0,1,0,3.51c0,2.17-.12,5.16-.25,8.47,0,1.15-.09,2.25-.14,3.29v.27l-.23,0c-2.51-.29-4.67-.57-6.21-.78a13.16,13.16,0,0,1-2.43-.43,13.74,13.74,0,0,1,2.46.12c1.53.12,3.68.33,6.17.59l-.25.24c0-1,.08-2.14.12-3.29.13-3.31.27-6.3.41-8.46A24.6,24.6,0,0,1,253,83.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.26,100.19a14.87,14.87,0,0,1,2.41,1.35c1.45.89,3.44,2.15,5.62,3.57l1,.64-.39.14c.6-2.2,1-4.25,1.28-5.69a13,13,0,0,1,.57-2.31,10.75,10.75,0,0,1-.23,2.37,55.63,55.63,0,0,1-1.13,5.79l-.09.33-.3-.19-1-.65c-2.17-1.42-4.13-2.72-5.53-3.69A14,14,0,0,1,233.26,100.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,71.62s4.61-1.55,7.05-.45c4.71,2.15,35.22,18.57,36.49,19.45S322.3,118.2,322.3,118.2l-11.35,7L294.77,103l-29.5-11.09s-4.47-5.76-5.19-10.61A24.09,24.09,0,0,1,260.94,71.62Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,93.05a32.43,32.43,0,0,1,1.19,3.21l2.8,7.76c2.22,6.06,3.89,11,3.65,11.1a4.66,4.66,0,0,1-.35-.85c-.26-.66-.55-1.44-.9-2.33-.75-2-1.79-4.7-2.89-7.74s-2-5.8-2.66-7.82c-.31-1-.54-1.84-.68-2.42A3.67,3.67,0,0,1,275,93.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.1,86.51a6.47,6.47,0,0,1-1.47-1.42,22.49,22.49,0,0,1-2.8-4.07A23.4,23.4,0,0,1,263,76.44a6.07,6.07,0,0,1-.36-2,62.94,62.94,0,0,0,2.67,6.34A66.62,66.62,0,0,0,269.1,86.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38,135.14a12.34,12.34,0,0,1-2.69.45,50.74,50.74,0,0,1-6.58.24,52,52,0,0,1-6.56-.62,11.94,11.94,0,0,1-2.66-.61,17.27,17.27,0,0,1,2.71.24c1.66.19,4,.39,6.52.47s4.87,0,6.54-.09A17.57,17.57,0,0,1,264.38,135.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2,78.35l.43,0a9,9,0,0,1,1.25.16,16.63,16.63,0,0,1,4.38,1.78,54.22,54.22,0,0,1,12.48,10.76l.15.17-.16.16c-.68.69-1.42,1.44-2.16,2.21l-.18-.43h2.84l.06.16c.89,2.32,1.83,4.75,2.79,7.24,1.08,2.81,2.13,5.54,3.11,8.11l0,0v.06a38.75,38.75,0,0,1-2.73,10.73,64.51,64.51,0,0,0-2.7,8.31,22.8,22.8,0,0,0-.62,5.71c0,1.34.19,2.07.15,2.07a2.45,2.45,0,0,1-.13-.52,13.23,13.23,0,0,1-.19-1.55,21.18,21.18,0,0,1,.47-5.78,63.37,63.37,0,0,1,2.6-8.39,38.55,38.55,0,0,0,2.64-10.61l0,.1c-1-2.57-2-5.3-3.13-8.1q-1.43-3.75-2.78-7.25l.24.16h-3.26l.42-.42,2.17-2.2v.33a56.5,56.5,0,0,0-12.26-10.83,17.81,17.81,0,0,0-4.26-1.88C247.79,78.45,247.2,78.4,247.2,78.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67,118.74a44.52,44.52,0,0,1-6.71.62,44.3,44.3,0,0,1-6.75.1,43.06,43.06,0,0,1,6.72-.62A42.63,42.63,0,0,1,227.67,118.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.94,129a1.91,1.91,0,0,1-.43-.07,10.44,10.44,0,0,1-1.23-.3,17.78,17.78,0,0,1-4.26-1.94,33.58,33.58,0,0,1-5.55-4.37c-1.94-1.85-3.95-4-6.08-6.38l-.16-.18.16-.17c.84-.86,1.55-1.95,2.48-2.93l.31.41-.81.44-3.07,1.66-.28.15-.1-.3a100.19,100.19,0,0,1-3.66-16.31c-.29-2.09-.45-3.78-.54-4.94-.05-.58-.06-1-.08-1.33a1.53,1.53,0,0,1,0-.47,1.5,1.5,0,0,1,.09.46l.17,1.32c.14,1.16.36,2.83.69,4.91a111.77,111.77,0,0,0,3.82,16.21l-.38-.15,3.08-1.67.81-.44,1.46-.79-1.14,1.2c-.89.93-1.61,2-2.49,2.93v-.35c2.12,2.34,4.1,4.54,6,6.39a35.06,35.06,0,0,0,5.42,4.41A23.59,23.59,0,0,0,250.94,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.7,131.31a13.22,13.22,0,0,1-2.85-.24,44.05,44.05,0,0,1-6.76-1.47,28.81,28.81,0,0,1-6.35-2.78,10.64,10.64,0,0,1-2.33-1.67c.05-.07,1,.53,2.51,1.35a35.88,35.88,0,0,0,6.32,2.6C261.37,130.63,265.73,131.12,265.7,131.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.09,135.32a16.3,16.3,0,0,0,11.77-15.72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256,82.11a32.76,32.76,0,0,1,11.16,9.43,1.55,1.55,0,0,0-.78.83l1.45.41q1.58,6.45,3.14,12.9L266,93l-2.4.25,2.25-2a51.53,51.53,0,0,1-7.4-7.87"
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "235.94 101.93 243.74 109.11 244.95 99.3 254.31 99.87 252.97 87.83 252.41 98 243.74 97.53 242.14 105.97",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.82 95.89 273.16 87.83 278.77 97 275.82 95.89",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.81,94.69a9.71,9.71,0,0,0-2.05,2,10.36,10.36,0,0,0-1,2.65c-.06,0-.17-.33-.14-.89a4.32,4.32,0,0,1,2.3-3.5C299.44,94.66,299.79,94.63,299.81,94.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.55,48.7a3.39,3.39,0,0,0-3.9.46,4.65,4.65,0,0,0-4.75,3.2,4.14,4.14,0,0,0-3.4,6.22,3.46,3.46,0,0,0,.63,6.53,3.32,3.32,0,0,0,4.68,4.66l8.33-17.48A3.4,3.4,0,0,0,216.55,48.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.66,70.42a14.09,14.09,0,0,1,4.75-18.5l.61-.39c6.85-3.89,14-.24,17.68,6.72l11.44,19,2.08,3.67-2.33,15.7-12.32-4.69-1.84-2.67s-7,3.12-11.17-3.18C216.54,83,212.89,76.43,209.66,70.42Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.75,89.26a18.32,18.32,0,0,0,6.67-7.8s1,5.84-5.62,9.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.3,75.11a1.07,1.07,0,0,0,1.46.35,1,1,0,0,0,.41-1.42,1.08,1.08,0,0,0-1.47-.35A1,1,0,0,0,215.3,75.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,73c.19,0,.54-.9,1.52-1.53s2-.6,2-.79-.24-.23-.7-.25a3,3,0,0,0-1.72.48,2.86,2.86,0,0,0-1.12,1.37C213,72.72,213.08,73,213.17,73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.93,70.12a1.07,1.07,0,0,0,1.46.35,1,1,0,0,0,.41-1.42,1.08,1.08,0,0,0-1.47-.35A1,1,0,0,0,223.93,70.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41,66.84c.19,0,.55-.9,1.52-1.53s2-.61,2-.79-.23-.23-.69-.25a3,3,0,0,0-1.73.48,2.92,2.92,0,0,0-1.12,1.37C222.28,66.55,222.32,66.83,222.41,66.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.87,76.15a7.78,7.78,0,0,0-1.77.74c-.26.13-.53.24-.68.09a1.43,1.43,0,0,1-.31-.84c-.16-.76-.32-1.55-.49-2.38a38.67,38.67,0,0,0-1.56-6,39.28,39.28,0,0,0,1.07,6.15c.18.82.36,1.61.53,2.36a1.72,1.72,0,0,0,.5,1.06.75.75,0,0,0,.64.1,1.58,1.58,0,0,0,.47-.22A7.3,7.3,0,0,0,223.87,76.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59,64.06c.28.18,1-.59,2-1.23s2-1,2-1.3c0-.15-.35-.27-.85-.26a3.71,3.71,0,0,0-1.77.58,3.49,3.49,0,0,0-1.25,1.36C220.48,63.64,220.47,64,220.59,64.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.66,70.2c.3.13.88-.49,1.72-1s1.65-.69,1.69-1c0-.16-.23-.33-.67-.38a2.74,2.74,0,0,0-1.61.37,2.83,2.83,0,0,0-1.13,1.21C211.49,69.83,211.52,70.13,211.66,70.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.38,67.12s-.89-5.06.42-7.23c1.6-2.62,4.24-.72,6-2.77s3.33-4.56,6.7-4.31c3.68.27,3.37,2.33,5.35,5,8,11,12.17,12.9,9.29,7.14-.32-.64,1-2.16-.35-4.81-1.78-3.43-4.19-7.43-6.39-9.25a10.79,10.79,0,0,0-6.74-2.36c-4.62-.3-8.93,2.42-11.65,4.59S204.9,62.31,208.38,67.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.67,65.08a2.05,2.05,0,0,1,.79-2.86c1.26-.65,3-.83,4.51,1.66,2.67,4.43-2.33,6.2-2.41,6.08S236.77,67,235.67,65.08Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.52,67.71s.11,0,.28,0a.9.9,0,0,0,.58-.34,2.23,2.23,0,0,0-.15-2.24,3,3,0,0,0-.88-1,1.05,1.05,0,0,0-.94-.24.46.46,0,0,0-.33.49c0,.16.1.23.08.25s-.14,0-.21-.22a.55.55,0,0,1,0-.38.68.68,0,0,1,.36-.37,1.23,1.23,0,0,1,1.22.2,3,3,0,0,1,1,1.07,2.33,2.33,0,0,1,0,2.59,1,1,0,0,1-.78.31C238.59,67.81,238.51,67.73,238.52,67.71Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.15,56.73a4.85,4.85,0,0,1-1.29,2,1.67,1.67,0,0,1-2.21,0c-.25-.27-.4-.67-.75-.77s-.8.24-1.14.52a3.3,3.3,0,0,1-4.16-.13,1.38,1.38,0,0,1-1.46,1.16,7.43,7.43,0,0,1-2-.5,2.1,2.1,0,0,0-2,.22c-.29.25-.47.63-.81.81-.6.32-1.31-.17-1.77-.68s-.94-1.12-1.62-1.12-1.11.55-1.58,1-1.23.74-1.7.31a1.22,1.22,0,0,1-.31-.91A3.33,3.33,0,0,1,210,55.45a4.55,4.55,0,0,1,6.53-5.27,4.61,4.61,0,0,1,7.09-2.59,3.33,3.33,0,0,1,5.79,2,3.17,3.17,0,0,1,2.84,1.17,1.81,1.81,0,0,1-.72,2.67,1.85,1.85,0,0,1-1.69,3.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29,76.14a.49.49,0,0,1,.25-.24.41.41,0,0,1,.3.09A2.61,2.61,0,0,1,229,78.22v0a1.73,1.73,0,0,1-2.63,1.32l-.82-.49Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.84,79.77a1.64,1.64,0,0,0,1.42-.19,1.42,1.42,0,0,0,.56-.53,1.56,1.56,0,0,0,.3-.83,3,3,0,0,0-.63-1.85,3.81,3.81,0,0,0-.32-.41.76.76,0,0,0-.55-.26.64.64,0,0,0-.48.36l-.21.39-.73,1.35a6.08,6.08,0,0,0-.6,1.29,5.63,5.63,0,0,0,.8-1.17l.8-1.31c.15-.23.3-.6.44-.58s.4.28.58.53a3,3,0,0,1,.59,1.65,1.39,1.39,0,0,1-.23.7,1.25,1.25,0,0,1-.44.47A3.19,3.19,0,0,1,226.84,79.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,53.26a1.22,1.22,0,0,1,.27,1,1.69,1.69,0,0,1-.54,1.09,1.82,1.82,0,0,1-1.47.44l.17-.15a5,5,0,0,1-.17,1.64,3,3,0,0,1-.47,1,2.28,2.28,0,0,1-2.54.74,2.89,2.89,0,0,1-.93-.67c-.19-.2-.27-.32-.26-.33s.13.08.34.24a3.41,3.41,0,0,0,.93.57,2.12,2.12,0,0,0,2.65-1.63,5.58,5.58,0,0,0,.17-1.55v-.17l.17,0a1.58,1.58,0,0,0,1.27-.35,1.53,1.53,0,0,0,.51-.92A2.44,2.44,0,0,0,231.84,53.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.23,48.65s-.09.1-.23.31a1.8,1.8,0,0,0-.31,1v.12l-.11-.05a6.44,6.44,0,0,0-3.19-.34,5.05,5.05,0,0,0-2,.73,4.18,4.18,0,0,0-1.49,1.72,4.37,4.37,0,0,0-.43,1.74,3.64,3.64,0,0,0,.37,1.62l.08.14-.16.05a2.91,2.91,0,0,0-1.66,1.39,2.82,2.82,0,0,0-.3,1.69,3.8,3.8,0,0,0,.56,1.46s-.12-.09-.28-.32a2.79,2.79,0,0,1-.45-1.11,2.94,2.94,0,0,1,.27-1.83,3.09,3.09,0,0,1,1.78-1.54l-.08.2a3.8,3.8,0,0,1-.42-1.75,4.54,4.54,0,0,1,2.06-3.7,5.13,5.13,0,0,1,2.07-.74,6.28,6.28,0,0,1,3.29.44l-.11.08a1.72,1.72,0,0,1,.4-1.06C217.1,48.71,217.22,48.64,217.23,48.65Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfHelp);
export default __webpack_public_path__ + "static/media/self-help.9a4a2e756c654c1d62a9fa718c40cb6b.svg";
export { ForwardRef as ReactComponent };